module.exports = __webpack_public_path__ + "static/media/ic_principal_mailbox.b47e2fbb.png";